export default __webpack_public_path__ + "static/media/Travel & Leisure 2.661bd5be.jpg";